import { useNavigate, useLocation } from "react-router-dom";
import { Home, Briefcase, Users, User, Plus, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DoorKnockerQuickQuote } from "@/components/leads/DoorKnockerQuickQuote";

export function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { icon: Home, label: "Home", path: "/" },
    { icon: Briefcase, label: "Jobs", path: "/jobs" },
    { icon: Users, label: "Leads", path: "/leads" },
    { icon: User, label: "Profile", path: "/profile" },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-background border-t border-border z-50 safe-area-inset-bottom">
      <div className="flex items-center justify-around px-2 py-2 max-w-md mx-auto">
        {navItems.slice(0, 2).map((item) => (
          <Button
            key={item.path}
            variant="ghost"
            size="sm"
            onClick={() => navigate(item.path)}
            className={`flex-1 flex-shrink-0 min-w-0 flex flex-col items-center gap-0.5 h-14 ${
              location.pathname === item.path ? "text-primary" : "text-muted-foreground"
            }`}
          >
            <item.icon className="h-5 w-5 flex-shrink-0" />
            <span className="text-xs truncate w-full text-center px-1">{item.label}</span>
          </Button>
        ))}

        {/* Center Quick Action */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              size="icon"
              className="h-12 w-12 rounded-full shadow-lg flex-shrink-0"
            >
              <Plus className="h-6 w-6" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="center" side="top" className="w-48">
            <DropdownMenuItem asChild>
              <DoorKnockerQuickQuote
                trigger={
                  <button className="flex w-full items-center gap-2 px-2 py-1.5">
                    <Zap className="h-4 w-4" />
                    Instant Quote
                  </button>
                }
              />
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate("/field-capture")}>
              New Inspection
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate("/estimates/new")}>
              New Estimate
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>

        {navItems.slice(2).map((item) => (
          <Button
            key={item.path}
            variant="ghost"
            size="sm"
            onClick={() => navigate(item.path)}
            className={`flex-1 flex-shrink-0 min-w-0 flex flex-col items-center gap-0.5 h-14 ${
              location.pathname === item.path ? "text-primary" : "text-muted-foreground"
            }`}
          >
            <item.icon className="h-5 w-5 flex-shrink-0" />
            <span className="text-xs truncate w-full text-center px-1">{item.label}</span>
          </Button>
        ))}
      </div>
    </div>
  );
}
